import { IGetaxReturnStatsResponse } from 'app/services/projects';
import PieChartStats from './PieChartStats';

const COLORS = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#DC3545',
  '#93C572',
];

interface ITaxReturnStatusStats {
  data: IGetaxReturnStatsResponse;
}

const MondayTaxReturnStatusStats = ({ data }: ITaxReturnStatusStats) => {
  return (
    <PieChartStats
      data={data.monday_statuses_count.map(({ status, count }) => ({
        name: status,
        value: count,
      }))}
      total={data.tax_returns_stats.total_tax_returns_count}
      colors={COLORS}
    />
  );
};

export default MondayTaxReturnStatusStats;
